import { useEffect } from 'react';
import { MaybeLoanID } from 'src/common/types';
import { ZillowHomeLoansURL } from 'src/utils/ZillowHomeLoansURL';
import * as RouteConfigurationService from 'src/services/config/domain/RouteConfigurationService/RouteConfigurationService.client';
import { isUUID } from '../../../../utils/validators/isUUID';

export const useRedirectUserToDashboardBounce = (loanID: MaybeLoanID) => {
    useEffect(() => {
        if (!isUUID(loanID)) {
            window.location.replace(
                new ZillowHomeLoansURL(RouteConfigurationService.Domain.ApplicationRoute.DASHBOARD_BOUNCE).resolvedURL
            );
        }
    }, [loanID]);
};
